module.exports = __webpack_public_path__ + "static/media/archive.79ac4984.svg";